(function() {
  var input = document.getElementById('search-input');
  var suggestions = document.getElementById('search-suggestions');
  var searchData = [];
  var searchDataLoaded = false;
  if (!input || !suggestions) return;
  // Load custom search data from page endpoint
  fetch('/pages/search-data')
    .then(function(res) {
      if (!res.ok) throw new Error('Search data not found');
      return res.text();
    })
    .then(function(text) {
      try {
        searchData = JSON.parse(text);
        searchDataLoaded = true;
      } catch (e) {
        searchData = [];
      }
    })
    .catch(function(error) {
      searchData = [];
    });

  var synonyms = {
    'retinol': 'retinal',
    'vit c': 'vitamin c',
    'retin a': 'retinal',
    'L': 'Enlighten',
    '4': 'Smooth Serum',
    '5': 'Ultimate A',
    '2+': 'C Forte',
    '3': 'Zinc Shade',
    '0': 'Calming Cleanse',
    '1': 'Hydroxy Cleanser',
  };

  var synonymKeys = Object.keys(synonyms);

  function distance(a, b) {
    var m = [];
    for (var i = 0; i <= b.length; i++) m[i] = [i];
    for (var j = 0; j <= a.length; j++) m[0][j] = j;
    for (var i = 1; i <= b.length; i++) {
      for (var j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
          m[i][j] = m[i - 1][j - 1];
        } else {
          m[i][j] = Math.min(m[i - 1][j - 1] + 1, Math.min(m[i][j - 1] + 1, m[i - 1][j] + 1));
        }
      }
    }
    return m[b.length][a.length];
  }

  function mapQuery(q) {
    var lower = q.toLowerCase();
    if (synonyms[lower]) return synonyms[lower];
    var best = null;
    var minDist = 2; // small typo tolerance
    synonymKeys.forEach(function(k) {
      var d = distance(lower, k);
      if (d < minDist) {
        best = synonyms[k];
        minDist = d;
      }
    });
    return best || q;
  }

  function normalizeUrl(url) {
    // Remove domain and protocol, keep just the path
    var cleanUrl = url;
    if (url.startsWith('http')) {
      cleanUrl = new URL(url).pathname;
    }

    // Remove query parameters (everything after ?)
    var questionMarkIndex = cleanUrl.indexOf('?');
    if (questionMarkIndex !== -1) {
      cleanUrl = cleanUrl.substring(0, questionMarkIndex);
    }

    return cleanUrl;
  }

  function shouldHideProduct(productUrl) {
    if (!searchData || !Array.isArray(searchData)) {
      return false; // If no search data, don't hide anything
    }

    var normalizedUrl = normalizeUrl(productUrl);

    var product = searchData.find(function(p) {
      var searchDataUrl = normalizeUrl(p.url);
      return searchDataUrl === normalizedUrl;
    });

    return product && product.hide_from_search === true;
  }

  function getProductPriority(productUrl) {
    if (!searchData || !Array.isArray(searchData)) {
      return false;
    }

    var normalizedUrl = normalizeUrl(productUrl);
    var product = searchData.find(function(p) {
      var searchDataUrl = normalizeUrl(p.url);
      return searchDataUrl === normalizedUrl;
    });

    return product && product.prioritise_in_search === true;
  }

  function localMatches(q) {
    if (!searchData || !Array.isArray(searchData)) {
      return [];
    }
    var term = q.toLowerCase();

    var matches = searchData.filter(function(p) {
      // Skip products that are hidden from search
      if (p.hide_from_search === true) {
        return false;
      }

      var titleMatch = p.title && p.title.toLowerCase().includes(term);
      var handleMatch = p.handle && p.handle.toLowerCase().includes(term);
      var tagsMatch = p.tags && p.tags.toLowerCase().includes(term);
      var typeMatch = p.product_type && p.product_type.toLowerCase().includes(term);
      var vendorMatch = p.vendor && p.vendor.toLowerCase().includes(term);
      var ingredientsMatch = p.ingredients && p.ingredients.toLowerCase().includes(term);
      var fullTextMatch = p.full_text && p.full_text.toLowerCase().includes(term);
      var summaryMatch = p.summary_text && p.summary_text.toLowerCase().includes(term);
      var evidenceMatch = p.evidence_text && p.evidence_text.toLowerCase().includes(term);
      var descriptionMatch = p.description && p.description.toLowerCase().includes(term);
      var searchTermsMatch = p.search_terms && p.search_terms.toLowerCase && p.search_terms.toLowerCase().includes(term);

      return titleMatch || handleMatch || tagsMatch || typeMatch || vendorMatch ||
             ingredientsMatch || fullTextMatch || summaryMatch || evidenceMatch ||
             descriptionMatch || searchTermsMatch;
    });

    // Sort matches: prioritized products first, then regular products
    matches.sort(function(a, b) {
      var aPriority = a.prioritise_in_search === true ? 1 : 0;
      var bPriority = b.prioritise_in_search === true ? 1 : 0;
      return bPriority - aPriority; // Higher priority first
    });

    return matches.map(function(p){ return {title: p.title, url: p.url, prioritise_in_search: p.prioritise_in_search}; }).slice(0,10);
  }

  function renderSuggestions(query, products, articles) {
    var searchLabel = 'See all for "' + query + '"';
    var html = '<div class="suggestions-container wrapper rel">';
    html += '<div class="suggest-col products">';
    html += '<h4>Products</h4>';
    if (products && products.length > 0) {
      products.forEach(function(p) {
        html += '<a href="' + p.url + '">' + p.title + '</a>';
      });
    } else {
      html += '<p>No products found</p>';
    }
    html += '</div>';
    html += '<div class="suggest-col articles">';
    html += '<h4>Blog posts</h4>';
    if (articles && articles.length > 0) {
      articles.forEach(function(a) {
        html += '<a href="' + a.url + '">' + a.title + '</a>';
      });
    } else {
      html += '<p>No articles found</p>';
    }
    html += '</div>';
    html += '<div class="suggest-col search-link">';
    html += '<a class="big-btn bg-purple" href="/search?q=' + encodeURIComponent(query) + '">' + searchLabel + '</a>';
    html += '</div>';
    html += '</div>';
    suggestions.innerHTML = html;
    suggestions.classList.remove('hidden');
  }

  function fetchSuggestions(query) {
    // If search data isn't loaded yet, wait a bit and try again
    if (!searchDataLoaded) {
      setTimeout(function() {
        fetchSuggestions(query);
      }, 100);
      return;
    }

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product,article&resources[limit]=16')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        // var products = []
        var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];

        // Filter out hidden products from API results and add priority info
        products = products.filter(function(p) {
          return !shouldHideProduct(p.url);
        }).map(function(p) {
          // Add priority information to API products
          p.prioritise_in_search = getProductPriority(p.url);
          return p;
        });

        // console.log(products)
        // Add local matches from metafields
        var local = localMatches(query);
        local.forEach(function(p){
          if (!products.some(function(pr){ return pr.title === p.title; })) {
            products.push(p);
          }
        });

        // Sort combined products: prioritized products first
        products.sort(function(a, b) {
          var aPriority = a.prioritise_in_search === true ? 1 : 0;
          var bPriority = b.prioritise_in_search === true ? 1 : 0;
          return bPriority - aPriority; // Higher priority first
        });

        products = products.slice(0,10);
        articles = articles.slice(0,6);
        renderSuggestions(query, products, articles);
      })
      .catch(function(error) {
        // Silently handle search errors
      });
  }

  var timer;
  input.addEventListener('input', function() {
    clearTimeout(timer);
    var q = input.value.trim();
    if (!q) {
      suggestions.classList.add('hidden');
      suggestions.innerHTML = '';
      return;
    }
    timer = setTimeout(function() {
      var mapped = mapQuery(q);
      fetchSuggestions(mapped);
    }, 300);
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('#search-bar')) {
      suggestions.classList.add('hidden');
    }
  });

  // Add missing CSS for mobile search dropdown visibility
  var style = document.createElement('style');
  style.textContent = `
    @media (max-width: 1023px) {
      #header-search-dropdown .dropdown {
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s, visibility 0.3s;
      }
      #header-search-dropdown.active .dropdown {
        opacity: 1;
        visibility: visible;
      }
    }
  `;
  document.head.appendChild(style);

  // Mobile search button handler
  var searchBtn = document.getElementById('search-btn');
  var searchDropdown = document.getElementById('header-search-dropdown');

  if (searchBtn && searchDropdown) {
    searchBtn.addEventListener('click', function(e) {
      // Small delay to ensure dropdown is visible before focusing
      setTimeout(function() {
        if (searchDropdown.classList.contains('active')) {
          input.focus();
        }
      }, 350); // Longer delay to account for CSS transition
    });
  }
})();
